import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class TranslocoTitleStrategy extends TitleStrategy {
	private readonly title = inject(Title);
	private readonly transloco = inject(TranslocoService);
	private last: RouterStateSnapshot | null = null;

	constructor() {
		super();
		this.transloco.langChanges$.subscribe(() => {
			if (this.last) this.updateTitle(this.last);
		});
	}

	override updateTitle(snapshot: RouterStateSnapshot): void {
		this.last = snapshot;
		const raw = this.buildTitle(snapshot);
		if (!raw) {
			this.title.setTitle(this.transloco.translate('brand.product'));
			return;
		}
		this.title.setTitle(raw.includes('.') ? this.transloco.translate(raw) : raw);
	}
}
